export default __webpack_public_path__ + "static/media/empty.1c6b52dc.svg";